import Phaser from "phaser";
import homeBg from "@assets/imgs/backgrounds/home-bg.png";
import homeLogo from "@assets/imgs/home/home-logo.png";
import monsterPortal from "@assets/imgs/portals/monster-portal.png";
import { StartBtn } from "@phaser/ui/btns/StartBtn";
import { VolumeBtn } from "@phaser/ui/btns/VolumeBtn";
import { HelpBtn } from "@phaser/ui/btns/HelpBtn";
import { SArrowBtn } from "@phaser/ui/btns/SArrowBtn";
import { BestPanel } from "@/phaser/ui/home/BestPanel";
import { BottomNavBar } from "@phaser/ui/navs/BottomNavBar";
import { AudioManager } from "@/phaser/core/audio/AudioManager";
import { StageLoader } from "@phaser/core/stages/StageLoader";
import { CloseXBtn } from "@phaser/ui/btns/CloseXBtn";
import monsterCardModalBg from "@assets/imgs/modals/monster-card-modal-bg.png";
import modalBg from "@assets/imgs/modals/modal-bg.png";
import helpModal0 from "@assets/imgs/modals/help-modal-0.png";
import helpModal1 from "@assets/imgs/modals/help-modal-1.png";
import helpModal2 from "@assets/imgs/modals/help-modal-2.png";
import helpModal3 from "@assets/imgs/modals/help-modal-3.png";
import helpModal4 from "@assets/imgs/modals/help-modal-4.png";
import codexBg from "@assets/imgs/backgrounds/codex-bg.png";
import { preloadMonsters } from "@/phaser/core/monsters/monsterCatalog";
import sModalBg from "@assets/imgs/modals/s-modal-bg.png";
import { HomeBtn } from "@phaser/ui/btns/HomeBtn";
import { ResumeBtn } from "@phaser/ui/btns/ResumeBtn";
import { preloadObstacles } from "@/phaser/core/obstacles/obstaclesCatalog";
import { TimeBar } from "@/phaser/ui/game/TimeBar";
import { ShareBtn } from "@phaser/ui/btns/ShareBtn";
import { monsterCountManager } from "@/phaser/core/monsters/MonsterCountManager";
import { GameDataCache } from "@phaser/core/cache/GameDataCache";
import { getHighScore } from "@/phaser/core/storage/highScoreStorage";
import shopBg from "@assets/imgs/backgrounds/shop-bg.png";
import shopItemSlotBg from "@assets/imgs/shop/shop-item-slot-bg.png";
import { PurpleBtn } from "@phaser/ui/btns/PurpleBtn";
import { BlueBtn } from "@phaser/ui/btns/BlueBtn";
import { RedBtn } from "@phaser/ui/btns/RedBtn";
import { coinManager } from "@/phaser/core/game/CoinManager";
import { CoinShowPanel } from "@phaser/ui/shop/CoinShowPanel";
import coinIcon from "@assets/imgs/icons/coin-icon.png";
import { shopInventoryManager } from "@phaser/core/shop/ShopInventoryManager";
import { shopEquipManager } from "@phaser/core/shop/ShopEquipManager";
import sToastBg from "@assets/imgs/toasts/s-toast-bg.png";
import { preloadArrowSkins } from "@phaser/core/skins/arrowSkinCatalog";
import { preloadAudio } from "@phaser/core/audio/audioCatalog";
import stageCrackAnim from "@assets/imgs/game/stage-crack-anim.png";
import sunburstFx from "@assets/imgs/shop/sunburst-fx.png";
import monsterPortalSpin from "@assets/imgs/portals/monster-portal-spin.png";
import monsterPortalSpinBlur from "@assets/imgs/portals/monster-portal-spin-blur.png";
import gameoverText from "@assets/imgs/game/gameover-text.png";
import { APP_VERSION, COPYRIGHT } from "@/constants/app";
import { LanguageBtn } from "../ui/btns/LanguageBtn";

export class LoadingScene extends Phaser.Scene {
  private loadingEvent?: Phaser.Time.TimerEvent;
  private loadingText?: Phaser.GameObjects.Text;

  private isLoadComplete = false;
  private isInitComplete = false;
  private hasStarted = false;

  constructor() {
    super("LoadingScene");
  }

  preload() {
    // 로딩 완료 시 호출
    this.load.once("complete", () => {
      this.isLoadComplete = true;
      this.tryStartNextScene();
    });
    // ===== 공통 이미지 =====
    this.load.image("home-bg", homeBg);
    this.load.image("home-logo", homeLogo);
    this.load.image("codex-bg", codexBg);
    this.load.image("shop-bg", shopBg);
    this.load.image("monster-portal", monsterPortal);
    this.load.image("shop-item-slot-bg", shopItemSlotBg);
    this.load.image("coin-icon", coinIcon);
    this.load.spritesheet("stage-crack-anim", stageCrackAnim, {
      frameWidth: 200,
      frameHeight: 1366,
    });
    this.load.image("sunburst-fx", sunburstFx);
    this.load.image("monster-portal-spin", monsterPortalSpin);
    this.load.image("monster-portal-spin-blur", monsterPortalSpinBlur);
    this.load.image("gameover-text", gameoverText);
    // ===== 모달 / 토스트 =====
    this.load.image("modal-bg", modalBg);
    this.load.image("s-modal-bg", sModalBg);
    this.load.image("help-modal-0", helpModal0);
    this.load.image("help-modal-1", helpModal1);
    this.load.image("help-modal-2", helpModal2);
    this.load.image("help-modal-3", helpModal3);
    this.load.image("help-modal-4", helpModal4);
    this.load.image("monster-card-modal-bg", monsterCardModalBg);
    this.load.image("s-toast-bg", sToastBg);

    // ===== 몬스터 / 장애물 / 아이템 =====
    preloadMonsters(this);
    preloadObstacles(this);
    preloadArrowSkins(this);

    // ===== 스테이지 =====
    StageLoader.preloadPreviews(this);
    StageLoader.preloadBackgrounds(this);

    // ===== UI =====
    StartBtn.preload(this);
    LanguageBtn.preload(this);
    VolumeBtn.preload(this);
    HelpBtn.preload(this);
    SArrowBtn.preload(this);
    CloseXBtn.preload(this);
    HomeBtn.preload(this);
    ResumeBtn.preload(this);
    ShareBtn.preload(this);
    BestPanel.preload(this);
    BottomNavBar.preload(this);
    TimeBar.preload(this);
    PurpleBtn.preload(this);
    BlueBtn.preload(this);
    RedBtn.preload(this);
    CoinShowPanel.preload(this);

    // ===== 오디오 =====
    preloadAudio(this);
    // AudioManager.preload(this);
  }

  async create() {
    const { width, height } = this.scale;

    // 배경
    const bg = this.add.image(width / 2, height / 2, "home-bg");
    bg.setDisplaySize(width, height);

    // 어둡기 오버레이
    const overlay = this.add.rectangle(
      width / 2,
      height / 2,
      width,
      height,
      0x000000,
      0.5,
    );
    overlay.setOrigin(0.5);

    // 게임 로고
    const logo = this.add.image(width / 2, height * 0.38, "home-logo");
    logo.setOrigin(0.5);
    logo.setScale(0.6);

    // 포탈 이미지
    const portal = this.add.image(width / 2, height / 2, "monster-portal");
    portal.setOrigin(0.5);

    // 로딩 텍스트
    this.loadingText = this.add
      .text(width / 2, height * 0.6, "Opening the portal.", {
        fontFamily: "Luckiest Guy",
        fontSize: "30px",
        color: "#FFFFFF",
      })
      .setOrigin(0.5);

    let dotCount = 1;

    this.loadingEvent = this.time.addEvent({
      delay: 400,
      loop: true,
      callback: () => {
        dotCount++;
        if (dotCount > 3) dotCount = 1;
        this.loadingText?.setText(`Opening the portal${".".repeat(dotCount)}`);
      },
    });

    // 버전 텍스트
    this.add
      .text(width / 2, height * 0.95, `${APP_VERSION}\n${COPYRIGHT}`, {
        fontFamily: "Luckiest Guy",
        fontSize: "30px",
        color: "#FFFFFF",
      })
      .setOrigin(0.5);

    // ===== 초기화 작업 =====
    await this.runInitializers();

    this.isInitComplete = true;
    this.tryStartNextScene();
  }

  // ===== 초기화 작업 =====
  private async runInitializers() {
    await monsterCountManager.init();
    await coinManager.init();
    await shopInventoryManager.init();
    await shopEquipManager.init();
    await AudioManager.init(this);

    GameDataCache.prepareAll();

    const bestScore = await getHighScore();
    this.registry.set("bestScore", bestScore);
  }

  // 로드 검사 후 홈 씬으로 이동
  private tryStartNextScene() {
    if (this.hasStarted) return;
    if (!this.isLoadComplete) return;
    if (!this.isInitComplete) return;

    this.hasStarted = true;
    this.loadingEvent?.remove();
    this.scene.start("HomeScene");
  }
}
